<template>
    <select v-model="selected" class="form-control selecter">
      <option v-bind:value="10">10</option>
      <option v-bind:value="20">20</option>
      <option v-bind:value="50">50</option>
    </select>
</template>

<script>
export default {
    name: 'Limit',
    props: {
        shopid: {
            type: String
        }
    },
    watch: {
        selected (value) {
            this.$emit('change', value);
        }
    },
    data () {
        return { selected: 10 };
    }
};
</script>

<style lang="scss" scoped>
    .selecter{
      margin-bottom: 1rem;
      width: 100px;
    }
</style>
